/**
 *
 * @param {*} cookies object of cookies to filter
 * @returns object of cookies that start with 'ge_'
 */
export default function getGeCookies(cookies: Record<string, unknown>) {
  return Object.fromEntries(Object.entries(cookies).filter(([key]) => key.startsWith('ge_')))
}
